module.exports = __webpack_public_path__ + "files/73fc97b6fca9afd9f0c340c088994c17.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bold-webfont.ttf
// module id = 922
// module chunks = 60